// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

import Vue from 'vue'
import Router from 'vue-router'
import store from "../vuex/store.js";
import Cookies from "js-cookie";


// Admin pages
import DeletedAccount from '../pages/DeletedAccount.vue'
import ConsecratedDetails from '../pages/Details.vue'
import Inicio from '../pages/Inicio.vue'
import Support  from '../pages/Support.vue'
import Politics from '../pages/Politics.vue'
import Terms from '../pages/Terms.vue'
import CookiesPage from '../pages/Cookies.vue'
import NewsDetail from '../pages/NewsDetail.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: Inicio,
  },
  { path: '*', component: NotFound },
  { path: '/cookies', component: CookiesPage },
  { path: '/soporte', component: Support },
  { path: '/borrar-cuenta', component: DeletedAccount },
  { path: '/politicas', component: Politics },
  { path: '/terminos', component: Terms },
  {
    path: '/profile',
    component: ConsecratedDetails,
    children: [
      {
        path: ':code',
        name: 'ConsecratedDetails',
        component: ConsecratedDetails
      },
    ]
  },
  {
    path: '/detalle_noticia',
    component: NewsDetail,
    meta: { requiresAuth: false },
    children: [
      {
        path: ':id',
        name: 'detalle_noticia',
        component: NewsDetail,
        meta: { requiresAuth: false }
      },
    ]
  },
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default router
